import fetch from '@/common/js/http';

const contract = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getContrachlist({commit}, params) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'contract/page',
                    method: 'get',
                    params:params
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        eidtContrach({commit}, params) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'contract',
                    method: 'put',
                    data: params
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        addContrach({cmmmit}, params) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'contract',
                    method: 'post',
                    data: params
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getAllCustomer({commit}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'customer/all',
                    method: 'get',
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getContrachAll({commit},params){
            return new Promise((resolve,reject)=>{
                return fetch({
                    url:"contract/all",
                    method:'get',
                    params:params
                }).then(success=>{
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getCollectInfo({commmit},params){
            return new Promise((resolve,reject)=>{
                return fetch({
                    url:'collect/all',
                    method:'get',
                    params:params
                }).then(success=>{
                    resolve(success)
                },error=>{
                    reject(error)
                })
            })
        },
        editCollectInfo({commit},params){
            return new Promise((resolve,reject)=>{
                return fetch({
                    url:"collect",
                    method:'put',
                    data:params
                }).then(success=>{
                    resolve(success)
                },error=>{
                    reject(Error)
                })
            })
        },
        deleteContract({cmmmit}, id) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'contract/' + id,
                    method: 'delete',
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
    }
}
export default contract



// WEBPACK FOOTER //
// ./src/vuex/modules/contract.js